<template>
  <div class="sidebar-left">
    <div class="sidebar">
      <div class="sidebar-file-manager">
        <div class="sidebar-inner">
          <div class="dropdown dropdown-actions">
            <b-dropdown v-ripple.400="'rgba(255, 255, 255, 0.15)'" class="btn-add" :text="$t('btn_add_new')" variant="primary" right>
              <b-dropdown-item @click="onClickNewVault()">
                <span class="iconfont icon-vault-sr icon-24 icon" /> {{ $t('vault_title') }}
              </b-dropdown-item>
              <b-dropdown-item
                v-if="this.$router.currentRoute.path.indexOf('/vaults/') > -1"
                v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                v-b-modal.modal-center
                :disabled="!isEditable"
                @click="onClickNewFolder()"
                ><FeatherIcon icon="FolderIcon" size="24" class="icon" /> {{ $t('folder_title') }}
              </b-dropdown-item>
              <b-dropdown-item
                v-if="this.$router.currentRoute.path.indexOf('/vaults/') > -1"
                v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                v-b-modal.modal-center
                :disabled="!isEditable"
                @click="onClickNewDocument()"
              >
                <FeatherIcon icon="FileTextIcon" size="24" class="icon" />{{ $t('file_title') }}
              </b-dropdown-item>
            </b-dropdown>
          </div>

          <div class="sidebar-list group-tabs">
            <div class="list-group">
              <a
                id="left-side-bar-vault"
                class="list-group-item list-group-item-action d-flex align-items-center"
                :class="{ active: vaultActive }"
                @click="onClickVault"
              >
                <span class="iconfont icon-vault-sr icon-24 icon" />
                <span class="align-middle">{{ $t('vaults_title') }}</span>
              </a>
              <a
                id="left-side-bar-document-gpt"
                class="list-group-item list-group-item-action"
                :class="{ active: documentGptActive }"
                @click="onClickDocumentGpt"
              >
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 80 80"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  alt="logo"
                  class="logo-document-gpt icon"
                >
                  <path
                    d="M74.7261 32.7414C75.6349 30.0484 75.9502 27.1948 75.6508 24.3718C75.3515 21.5488 74.4443 18.8215 72.9902 16.3724C70.8347 12.6681 67.5421 9.73516 63.5876 7.99696C59.633 6.25876 55.2211 5.80514 50.9883 6.70156C49.0792 4.57858 46.7324 2.88248 44.1051 1.7268C41.4778 0.571125 38.6306 -0.0174776 35.7542 0.000395158C31.4265 -0.00990622 27.2073 1.33607 23.705 3.84428C20.2026 6.35248 17.5979 9.89332 16.2666 13.9563C13.4473 14.5257 10.7839 15.6828 8.45459 17.3501C6.12527 19.0174 4.18381 21.1564 2.76016 23.624C0.587381 27.3181 -0.340092 31.5977 0.111506 35.8455C0.563105 40.0933 2.37043 44.0898 5.27283 47.2586C4.36405 49.9516 4.04879 52.8052 4.34816 55.6282C4.64752 58.4512 5.5546 61.1785 7.00867 63.6276C9.16447 67.3318 12.4571 70.2645 16.4116 72.0026C20.366 73.7408 24.7779 74.1945 29.0106 73.2984C30.9198 75.4214 33.2665 77.1175 35.8938 78.2732C38.5211 79.4289 41.3683 80.0175 44.2448 79.9996C48.5745 80.0107 52.7959 78.6642 56.2997 76.1544C59.8035 73.6446 62.4085 70.1013 63.7389 66.0358C66.5581 65.4664 69.2215 64.3093 71.5509 62.642C73.8802 60.9747 75.8216 58.8357 77.2453 56.3681C79.4153 52.6742 80.3406 48.3958 79.8878 44.1497C79.4351 39.9035 77.6277 35.9089 74.7261 32.7414ZM44.2513 74.7698C40.6971 74.7748 37.2542 73.5466 34.525 71.3002C34.648 71.234 34.8639 71.1172 35.0046 71.0322L51.1483 61.8312C51.5534 61.6037 51.8899 61.2739 52.1231 60.8756C52.3562 60.4773 52.4777 60.0249 52.4749 59.565V37.1084L59.2986 40.996C59.3344 41.0136 59.3652 41.0396 59.3884 41.0718C59.4115 41.1039 59.4262 41.1413 59.4312 41.1804V59.7778C59.4261 63.7499 57.8256 67.5581 54.9803 70.3682C52.1351 73.1783 48.277 74.761 44.2513 74.7698ZM11.6057 61.0128C9.82536 57.9776 9.18373 54.4213 9.79308 50.9664C9.91295 51.0374 10.1223 51.1636 10.2726 51.2488L26.4162 60.4496C26.8185 60.6817 27.2762 60.8041 27.7422 60.8041C28.2082 60.8041 28.6658 60.6817 29.0681 60.4496L48.7779 49.2206V56.9958C48.7802 57.0355 48.7724 57.0751 48.7554 57.1112C48.7384 57.1472 48.7127 57.1785 48.6804 57.2024L32.3609 66.4994C28.8701 68.483 24.7245 69.0194 20.8334 67.9908C16.9424 66.9622 13.6237 64.4527 11.6057 61.0128ZM7.35874 26.2388C9.13135 23.1997 11.9311 20.8727 15.2676 19.6654C15.2676 19.8026 15.2596 20.0456 15.2596 20.2142V38.616C15.2567 39.0756 15.378 39.5277 15.6108 39.9257C15.8437 40.3238 16.1799 40.6534 16.5847 40.8808L36.2944 52.1084L29.4709 55.9958C29.4372 56.0177 29.3986 56.031 29.3584 56.0346C29.3182 56.0382 29.2778 56.0319 29.2407 56.0164L12.9195 46.7114C9.43492 44.7202 6.89272 41.447 5.8503 37.6092C4.80789 33.7715 5.35035 29.6825 7.35874 26.2388ZM63.4208 39.1112L43.7109 27.8822L50.5345 23.9962C50.5682 23.9743 50.6068 23.961 50.6469 23.9574C50.6871 23.9538 50.7275 23.9602 50.7646 23.9758L67.0858 33.2728C69.5863 34.6979 71.6235 36.7964 72.959 39.3225C74.2945 41.8487 74.8729 44.698 74.6265 47.5368C74.3801 50.3756 73.3192 53.0864 71.5679 55.3518C69.8166 57.6172 67.4474 59.3433 64.7378 60.3282V41.376C64.7415 40.9172 64.6216 40.4656 64.3902 40.0676C64.1587 39.6696 63.8242 39.3395 63.4208 39.1112ZM70.2122 29.0256C70.0924 28.953 69.883 28.8284 69.7329 28.7434L53.589 19.5424C53.1866 19.3107 52.729 19.1886 52.2631 19.1886C51.7972 19.1886 51.3397 19.3107 50.9373 19.5424L31.2275 30.7716V22.9964C31.2253 22.9567 31.233 22.9171 31.25 22.881C31.267 22.845 31.2928 22.8137 31.325 22.7898L47.6446 13.5005C50.1448 12.0781 53.0037 11.3876 55.8871 11.5097C58.7704 11.6318 61.5589 12.5616 63.9263 14.1902C66.2936 15.8188 68.142 18.079 69.2552 20.7062C70.3684 23.3334 70.7004 26.2191 70.2122 29.0256ZM27.5177 42.8838L20.6925 38.9962C20.6566 38.9786 20.6258 38.9526 20.6026 38.9203C20.5795 38.8881 20.5648 38.8508 20.5599 38.8116V20.2142C20.5618 17.3658 21.386 14.5769 22.9359 12.1739C24.4859 9.77086 26.6975 7.85318 29.3119 6.6453C31.9262 5.43741 34.8352 4.9893 37.6984 5.35342C40.5615 5.71754 43.2603 6.87882 45.4788 8.70133C45.3558 8.76758 45.1415 8.8843 44.9992 8.96947L28.8555 18.1703C28.4505 18.3975 28.114 18.727 27.8808 19.1251C27.6477 19.5231 27.5262 19.9753 27.5289 20.435L27.5177 42.8838ZM31.2243 34.9982L40.0028 29.9956L48.781 34.9949V44.997L40.0028 49.9966L31.2243 44.997L31.2243 34.9982Z"
                    fill="#9b9a9c"
                  />
                </svg>
                <span class="align-middle">Document GPT</span>
              </a>
              <a id="left-side-bar-recent" class="list-group-item list-group-item-action" :class="{ active: recentActive }" @click="onClickRecent">
                <FeatherIcon icon="ClockIcon" size="24" class="icon" />
                <span class="align-middle">{{ $t('recent_title') }}</span>
              </a>
              <a
                id="left-side-bar-favourite"
                class="list-group-item list-group-item-action"
                :class="{ active: favouriteActive }"
                @click="onClickFavouriteFiles"
              >
                <FeatherIcon icon="HeartIcon" size="24" class="icon" />
                <span class="align-middle">{{ $t('favourites_title') }}</span>
              </a>
              <a
                id="left-side-bar-deleted"
                class="list-group-item list-group-item-action"
                :class="{ active: deleteActive }"
                @click="onClickDeletedFiles"
              >
                <FeatherIcon icon="TrashIcon" size="24" class="icon" />
                <span class="align-middle">{{ $t('deleted_title') }}</span>
              </a>
            </div>
          </div>
          <hr />

          <!-- sidebar list items starts  -->
          <div id="left-folder-tree" class="sidebar-list group-vaults">
            <!-- links for file manager sidebar -->
            <h6 v-b-toggle.tree-own class="section-label px-2 mb-1 d-flex align-items-center">
              {{ $t('vaults_title') }}
              <b-avatar class="ml-1" :text="countOwn" :variant="`light-primary`" size="30" />
              <FeatherIcon class="when-open icon ml-auto" icon="ChevronDownIcon" size="20" />
              <FeatherIcon class="when-closed icon ml-auto" icon="ChevronRightIcon" size="20" />
            </h6>
            <b-collapse id="tree-own" visible class="collapse">
              <ContentTree />
            </b-collapse>
            <h6 v-b-toggle.tree-no-own class="section-label px-2 mb-1 d-flex align-items-center">
              {{ $t('vaults_shared_title') }}
              <b-avatar class="ml-1" :text="countShared" :variant="`light-primary`" size="30" />
              <FeatherIcon class="when-open icon ml-auto" icon="ChevronDownIcon" size="20" />
              <FeatherIcon class="when-closed icon ml-auto" icon="ChevronRightIcon" size="20" />
            </h6>
            <b-collapse id="tree-no-own" class="collapse">
              <ContentTree :is-own="false" />
            </b-collapse>
            <Favourite />
            <!-- storage status of file manager starts-->
            <div v-if="diskUsage" class="storage-status px-2">
              <h6 v-b-toggle.disk-usage class="section-label mb-1 d-flex align-items-center">
                {{ $t('usage_status_title') }}
                <FeatherIcon class="when-open icon ml-auto" icon="ChevronDownIcon" size="20" />
                <FeatherIcon class="when-closed icon ml-auto" icon="ChevronRightIcon" size="20" />
              </h6>
              <h6 class="mt-1">{{ $t('storage_status_title') }}</h6>
              <div class="d-flex align-items-center">
                <div v-if="maxStorage" class="file-manager-progress ml-1">
                  <span>{{ usedStorage }} / {{ maxStorage }}</span>
                  <b-progress class="h-6" :value="diskUsage.size" :max="profile.billing.subscription.usage.maxStorage"></b-progress>
                </div>
              </div>
              <b-collapse id="disk-usage" class="collapse">
                <h6 class="mt-1">{{ $t('document_analysis_credits') }}</h6>
                <div class="d-flex align-items-center">
                  <div class="file-manager-progress ml-1 h-5">
                    <span>{{ diskUsage.usage.ocrCountMonthly }} / {{ diskUsage.usage.ocrMaxCountMonthly }}</span>

                    <b-progress class="h-6" :value="diskUsage.usage.ocrCountMonthly" :max="diskUsage.usage.ocrMaxCountMonthly"></b-progress>
                  </div>
                </div>
                <h6 class="mt-1">ESign Credits</h6>
                <div v-if="diskUsage.usage.eSignEnabled" class="d-flex align-items-center mb-2">
                  <div class="file-manager-progress ml-1">
                    <span>{{ diskUsage.usage.eSignCountMonthly }} / {{ diskUsage.usage.eSignMaxCountMonthly }}</span>

                    <b-progress class="h-6" :value="diskUsage.usage.eSignCountMonthly" :max="diskUsage.usage.eSignMaxCountMonthly"></b-progress>
                  </div>
                </div>
                <div v-if="!diskUsage.usage.eSignEnabled" class="d-flex align-items-center mb-2">
                  <div class="file-manager-progress ml-1">
                    <span>0 / 0</span>
                    <b-progress class="h-6" :value="0" :max="0"></b-progress>
                    <p class="text-muted">Live ESign is disabled please change subscription to enable</p>
                  </div>
                </div>
              </b-collapse>
            </div>
          </div>

          <!-- side bar list items ends  -->
          <!-- sidebar menu links ends -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { VBToggle, BProgress, BAvatar, BCollapse, BDropdown, BDropdownItem, VBModal } from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import ContentTree from './ContentTree'
import Favourite from './Favourite.vue'
import { Notification } from 'element-ui'

export default {
  name: 'LeftSidebar',
  directives: {
    Ripple,
    'b-modal': VBModal,
    'b-toggle': VBToggle
  },
  components: {
    BProgress,
    BDropdown,
    BDropdownItem,
    ContentTree,
    Favourite,
    BCollapse,
    BAvatar
  },
  data: function() {
    return {
      folderName: '',
      nameState: null,
      perfectScrollbarSettings: {
        maxScrollbarLength: 60
      },
      vaultActive: false,
      documentGptActive: false,
      recentActive: false,
      deleteActive: false,
      favouriteActive: false,
      file: null
    }
  },
  computed: {
    ...mapState('userProfile', ['profile', 'diskUsage']),
    ...mapState('home', ['contents', 'isEditable']),
    ...mapState('contentTree', ['treeData']),
    usedStorage: function() {
      return this.calculateStorageString()
    },
    percentage: function() {
      return this.calculateStorage()
    },
    countOwn() {
      if (this.treeData.length === 0) return '0'
      const count = this.treeData[0].children.length
      return `${count || 0}`
    },
    countShared() {
      if (this.treeData.length <= 1) return '0'
      const count = this.treeData
        .filter((item, index) => index >= 1)
        .map(x => x.children.length)
        .reduce((a, b) => a + b)
      return `${count || 0}`
    },
    maxStorage: function() {
      const maxStorage = this.profile.billing && this.profile.billing.subscription ? this.profile.billing.subscription.usage.maxStorage : 104857600

      if (maxStorage <= 1073741824) {
        const formattedSize = Math.round((maxStorage / 1048576 + Number.EPSILON) * 100) / 100
        return formattedSize + ' MB'
      } else {
        const formattedSize = Math.round((maxStorage / 1073741824 + Number.EPSILON) * 100) / 100
        return formattedSize + ' GB'
      }
    }
  },
  watch: {
    $route: {
      handler(newVal, oldVal) {
        this.reset()
        if (this.$router.currentRoute.path === '/recent-contents') {
          this.recentActive = true
        } else if (this.$router.currentRoute.path === '/deleted') {
          this.deleteActive = true
        } else if (this.$router.currentRoute.path === '/favourites') {
          this.favouriteActive = true
        } else if (this.$router.currentRoute.path === '/document-gpt') {
          this.documentGptActive = true
        } else {
          this.vaultActive = true
        }
      },
      immediate: true
    }
  },
  created() {
    this.reset()
    if (this.$router.currentRoute.path === '/recent-contents') {
      this.recentActive = true
      this.onClickRecent()
    } else if (this.$router.currentRoute.path === '/deleted') {
      this.deleteActive = true
      this.onClickDeletedFiles()
    } else if (this.$router.currentRoute.path === '/favourites') {
      this.favouriteActive = true
      this.onClickFavouriteFiles()
    } else if (this.$router.currentRoute.path === '/document-gpt') {
      this.documentGptActive = true
      this.onClickDocumentGpt()
    } else {
      this.vaultActive = true
    }
    this.calculateStorage()
  },
  methods: {
    reset() {
      this.vaultActive = false
      this.recentActive = false
      this.deleteActive = false
      this.favouriteActive = false
      this.documentGptActive = false
    },
    onClickNewVault() {
      this.$store.dispatch('homeAddNew/onChangeModal', { self: this, visible: true, entityType: 'vault' })
    },
    onClickNewFolder() {
      if (this.$router.currentRoute.path !== '/vaults') {
        this.$store.dispatch('homeAddNew/onChangeModal', { self: this, visible: true, entityType: 'folder' })
      } else if (this.$router.currentRoute.path === '/vaults') {
        Notification.error('Unable to create a folder')
      }
    },
    onClickNewDocument() {
      if (this.$router.currentRoute.path !== '/vaults') {
        this.$store.dispatch('uploaderDetailsModal/onClickNewDocument', { self: this })
      } else if (this.$router.currentRoute.path === '/vaults') {
        Notification.error('Unable to create a file')
      }
    },
    onClickVault() {
      this.reset()
      this.vaultActive = true
      this.$router.push('/vaults')
    },
    onClickDocumentGpt() {
      this.reset()
      this.documentGptActive = true
      this.$router.push('/document-gpt')
    },
    onClickRecent() {
      this.reset()
      this.recentActive = true
      this.$router.push('/recent-contents')
    },
    onClickFavouriteFiles() {
      this.reset()
      this.favouriteActive = true
      this.$router.push('/favourites')
    },
    onClickDeletedFiles() {
      this.reset()
      this.deleteActive = true
      this.$router.push('/deleted')
    },
    calculateStorage() {
      var size = this.diskUsage.size
      if (size !== undefined) {
        const maxStorage = this.profile.billing && this.profile.billing.subscription ? this.profile.billing.subscription.usage.maxStorage : 104857600

        return Math.round((size * 100) / maxStorage)
      }
    },
    calculateStorageString() {
      const size = this.diskUsage.size || 0
      let suffix = ''
      let divisor = 1

      if (size > 1073741824 * 0.9) {
        divisor = 1073741824
        suffix = 'GB'
      } else if (size > 1048576 * 0.9) {
        divisor = 1048576
        suffix = 'MB'
      } else {
        divisor = 1024
        suffix = 'KB'
      }

      const formattedSize = parseFloat(((size / divisor) * 100) / 100).toFixed(2)
      return `${formattedSize} ${suffix}`
    },
    onFileSelected(event) {
      this.file = event.target.files
      this.$store.dispatch('contents/createDocument', {
        self: this,
        vaultId: this.$route.params.vaultId,
        folderId: this.$route.params.folderId,
        document: this.file
      })
      this.file = {}
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variables/_variables';
.logo-document-gpt path {
  fill: var(--primary) !important;
}
.collapsed > .when-open,
.not-collapsed > .when-closed {
  display: none;
}

.icon {
  margin-right: 10px;
}

.btn-add {
  margin-left: 1.5rem;
  min-width: 12rem;
}

.sidebar-list {
  overflow: auto;
}

.group-tabs {
  height: auto !important;
}

.group-vaults {
  height: calc(100% - 300px) !important;
}

.section-label {
  margin-top: 1rem;
}

hr {
  margin-bottom: 0;
  padding-bottom: 0;
}

.file-manager-progress {
  width: 100%;
  margin-right: 1em;
}

.h-6 {
  height: 6px;
}

.text-muted {
  color: $text-muted;
}
</style>
